import React, { useState } from "react";
import { Copy, Check, ExternalLink, Smartphone } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetDescription } from "@/components/ui/sheet";

const isMobile = () => typeof navigator !== "undefined" && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

const walletLinks = () => {
  const { host, pathname, search, href } = window.location;
  return [
    { id: "metamask", name: "MetaMask", url: `https://metamask.app.link/dapp/${host}${pathname}${search}` },
    { id: "trust", name: "Trust Wallet", url: `https://link.trustwallet.com/open_url?coin_id=60&url=${encodeURIComponent(href)}` },
  ];
};

function CopyLinkRow() {
  const [copied, setCopied] = useState(false);
  const copy = () => navigator.clipboard?.writeText(window.location.href).then(() => { setCopied(true); setTimeout(() => setCopied(false), 2000); });
  return (
    <div className="rounded-2xl border border-[#2A2E45] bg-[#12131C] p-4" data-testid="wallet-sheet-cdc">
      <div className="font-display font-bold">Crypto.com Onchain (DeFi Wallet)</div>
      <ol className="text-xs text-slate-400 mt-1 list-decimal pl-4 space-y-0.5">
        <li>Copy this page link</li>
        <li>Open the Onchain app and go to its DApp browser</li>
        <li>Paste the link, then tap Connect Wallet</li>
      </ol>
      <button onClick={copy} className="btn-tactile btn-ghost w-full mt-3 flex items-center justify-center gap-2 text-sm" data-testid="wallet-sheet-copy-link">
        {copied ? <><Check size={16} className="text-emerald-400" /> Link copied</> : <><Copy size={16} /> Copy page link</>}
      </button>
    </div>
  );
}

export function WalletAppsSheet({ open, onOpenChange }) {
  const mobile = isMobile();
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="bottom" className="bg-[#181A26] border-[#2A2E45] text-slate-100 rounded-t-3xl pb-[calc(1.5rem+env(safe-area-inset-bottom))] max-h-[90vh] overflow-y-auto" data-testid="wallet-apps-sheet">
        <SheetHeader className="text-left">
          <SheetTitle className="font-display text-2xl text-slate-100 flex items-center gap-2"><Smartphone className="text-orange-400" size={22} /> Open in your wallet</SheetTitle>
          <SheetDescription className="text-slate-400">
            {mobile ? "Your browser has no wallet. Open FLAME inside your wallet app to connect on Cronos." : "No wallet extension found. Install MetaMask, or open this page in a wallet app on your phone."}
          </SheetDescription>
        </SheetHeader>
        <div className="mt-5 space-y-3 max-w-lg">
          {mobile ? walletLinks().map((w) => (
            <a key={w.id} href={w.url} className="btn-tactile btn-flame w-full flex items-center justify-center gap-2 font-display" data-testid={`wallet-sheet-${w.id}`}>
              Open in {w.name} <ExternalLink size={16} />
            </a>
          )) : (
            <a href="https://metamask.io/download/" target="_blank" rel="noreferrer" className="btn-tactile btn-flame w-full flex items-center justify-center gap-2 font-display" data-testid="wallet-sheet-install-metamask">
              Install MetaMask <ExternalLink size={16} />
            </a>
          )}
          <CopyLinkRow />
        </div>
      </SheetContent>
    </Sheet>
  );
}
